export default __webpack_public_path__ + "static/media/vr-1.172fa6d3.png";